var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4502 4.34442C19.6614 1.56273 16.6114 3.8147e-06 12.6675 3.8147e-06H6.42692C4.53428 3.8147e-06 3 1.53429 3 3.42693V26.2386C3 28.1312 4.53429 29.6655 6.42692 29.6655H12.6675C16.6114 29.6655 19.6614 28.1028 22.4502 25.3211C25.2389 22.5394 26.8057 18.7667 26.8057 14.8328C26.8057 10.8989 25.2389 7.1261 22.4502 4.34442Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.04468,
    y: 20.9307,
    width: 6.05635,
    height: 6.05635,
    rx: 3.02818,
    fill: "#F53F17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69b80c6abf9299f69474b096033bc510.svg";
export { ForwardRef as ReactComponent };